import { API, API_GET_ID } from '../../Config'

export const GetUserImge = (id) => {
  return (
    API_GET_ID(API.GetUserbyID,id)
  )
}

